<template>
  <pt-previous-video-form class="pt-previous-video-form__page" :isEdit="is_edit" :id="id"></pt-previous-video-form>
</template>

<script>
import PtPreviousVideoForm from 'cps/famous-doctor-hall/pt-previous-video/pt-previous-video-form/withData'
export default {
  name: 'pt-previous-video-form__view',
  components: {
    'pt-previous-video-form': PtPreviousVideoForm
  },
  props: {
    isEdit: {
      type: [String, Boolean],
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  }
}
</script>
